import React from "react";
import { AppBar, Toolbar, Box, Avatar, Typography, Skeleton } from "@mui/material";
import BackButton from "./BackButton";

// Header estándar de la app: flecha atrás + (avatar opcional) + título,
// con la misma métrica (posición, espaciado, ancho máximo) que el header
// de profile.js. Usar en toda pantalla con navegación "atrás".
const PageHeader = ({
  title,
  subtitle,
  avatarSrc,
  avatarIcon,
  avatarNode,
  loading,
  rightSlot,
}) => {
  const hasAvatar = !!(avatarSrc || avatarIcon || avatarNode || loading);

  // Contenido del Toolbar extraído a función en vez de JSX porque se renderiza
  // dos veces: una real (fija, AppBar) y una invisible (spacer, ver abajo)
  // que reserva exactamente el mismo alto sin que cada pantalla tenga que
  // adivinar un mt/pt en px — eso es justamente lo que se desincronizaba
  // entre pantallas (algunas usaban 96px, otras 112px, ninguna coincidía con
  // el alto real, que además varía según haya avatar/subtítulo o no).
  const renderToolbarContent = () => (
    <Toolbar sx={{ display: "flex", justifyContent: "center", p: "10px", width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", width: "100%", maxWidth: { xs: "100%", md: "980px" }, mx: "auto" }}>
        <BackButton color="inherit" />

        {hasAvatar && (
          <Box sx={{ ml: 2 }}>
            {loading ? (
              <Skeleton variant="circular" width={56} height={56} />
            ) : avatarNode ? (
              avatarNode
            ) : (
              <Avatar src={avatarSrc} sx={{ width: 56, height: 56, border: "2.5px solid currentColor" }}>
                {avatarIcon}
              </Avatar>
            )}
          </Box>
        )}

        <Box sx={{ ml: 2, minWidth: 0 }}>
          {loading ? (
            <>
              <Skeleton variant="text" width={150} />
              <Skeleton variant="text" width={100} />
            </>
          ) : (
            <>
              <Typography variant="h5" noWrap>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" noWrap>
                  {subtitle}
                </Typography>
              )}
            </>
          )}
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        {rightSlot}
      </Box>
    </Toolbar>
  );

  return (
    <>
      <AppBar position="fixed" color="primary">
        {renderToolbarContent()}
      </AppBar>
      <Box sx={{ visibility: "hidden" }} aria-hidden="true">
        {renderToolbarContent()}
      </Box>
    </>
  );
};

export default PageHeader;
